<div class="space-y-6">

  <div class="onboarding-card-title" translate>ai-exam-onboarding.legal.title</div>
  <p class="onboarding-card-subtitle" translate>ai-exam-onboarding.legal.description</p>

  <!-- Informations sur le test -->
  <div class="bg-blue-50 border border-blue-200 rounded-xl p-5 space-y-4">
    <div class="flex items-center gap-3">
      <div class="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0">
        <mat-icon class="text-white icon-size-5">verified_user</mat-icon>
      </div>
      <h2 class="text-base font-semibold text-blue-900" translate>ai-exam-onboarding.legal.info.title</h2>
    </div>
    <ul class="text-[14px] text-blue-800 space-y-2 pl-1">
      <li class="flex items-start gap-2">
        <mat-icon class="text-blue-500 icon-size-4 mt-0.5 flex-shrink-0">person</mat-icon>
        <span translate>ai-exam-onboarding.legal.info.alone</span>
      </li>
      <li class="flex items-start gap-2">
        <mat-icon class="text-blue-500 icon-size-4 mt-0.5 flex-shrink-0">block</mat-icon>
        <span translate>ai-exam-onboarding.legal.info.no-tools</span>
      </li>
      <li class="flex items-start gap-2">
        <mat-icon class="text-blue-500 icon-size-4 mt-0.5 flex-shrink-0">schedule</mat-icon>
        <span translate>ai-exam-onboarding.legal.info.duration</span>
      </li>
    </ul>
  </div>

  <!-- Checkboxes d'engagement -->
  <form [formGroup]="form">
    <div class="space-y-3">
      <h3 class="text-base font-medium text-slate-800" translate>ai-exam-onboarding.legal.commitments.title</h3>

      <!-- Déclaration sur l'honneur -->
      <div
        class="flex items-center gap-3 p-3 bg-white rounded border border-slate-200 hover:border-primary-400 transition-colors cursor-pointer"
        (click)="toggleCheckbox('honorAccepted')">
        <mat-checkbox
          formControlName="honorAccepted"
          color="primary"
          (click)="$event.stopPropagation()">
        </mat-checkbox>
        <label class="text-[15px] text-slate-800 cursor-pointer flex-1" translate>
          ai-exam-onboarding.legal.commitments.honor
        </label>
      </div>

      <!-- CGU -->
      <div
        class="flex items-center gap-3 p-3 bg-white rounded border border-slate-200 hover:border-primary-400 transition-colors cursor-pointer"
        [class.opacity-50]="isLoading()"
        [class.pointer-events-none]="isLoading()"
        (click)="toggleCheckbox('termsAccepted')">
        <mat-checkbox
          formControlName="termsAccepted"
          color="primary"
          [disabled]="isLoading()"
          (click)="$event.stopPropagation()">
        </mat-checkbox>
        <label class="text-[15px] text-slate-800 cursor-pointer flex-1">
          <span translate>ai-exam-onboarding.legal.commitments.terms</span>
          <a
            href="#"
            class="text-primary-600 hover:text-primary-700 underline font-medium ml-1"
            (click)="openCguModal($event)">
            <span translate>ai-exam-onboarding.legal.commitments.terms-link</span>
          </a>
        </label>
      </div>
    </div>
  </form>

  <!-- Error Message -->
  <div *ngIf="errorMessage()" class="p-3 bg-red-50 border border-red-200 rounded-lg">
    <p class="text-sm text-red-700">{{ errorMessage() }}</p>
  </div>

  <div class="onboarding-actions">
    <button type="button" class="onboarding-btn-back" (click)="back.emit()">
      ← <span translate>ai-exam-onboarding.back</span>
    </button>
    <button type="button" class="onboarding-btn-primary flex-1"
      [disabled]="form.invalid || isLoading()" (click)="onConfirm()">
      @if (!isLoading()) {
      <span translate>ai-exam-onboarding.legal.confirm-button</span>
      } @else {
      <span class="inline-flex items-center justify-center gap-2">
        <mat-spinner [diameter]="18" [strokeWidth]="3"></mat-spinner>
        <span translate>ai-exam-onboarding.legal.saving</span>
      </span>
      }
    </button>
  </div>

</div>
